import { jsx as _jsx } from "react/jsx-runtime";
import moment from "moment";
import React from "react";
import { useInterval } from "react-use";
import { DurationValue } from "./DurationValue.js";
export const DurationCounter = ({ from, deltaMs = 0, active = true, isSimplified = false, noNegative = true, }) => {
    const [valueMs, seValueMs] = React.useState(Date.now() - moment(from).valueOf() + deltaMs);
    useInterval(() => {
        seValueMs(Date.now() - moment(from).valueOf() + deltaMs);
    }, active ? 1000 : null);
    return (_jsx(DurationValue, { isSimplified: isSimplified, noNegative: noNegative, valueMs: valueMs }));
};
//# sourceMappingURL=DurationCounter.js.map